import React from "react";

function EpTable(props) {
  return (
    <table className="table-layers-results table-spaces">
      <thead>
        <tr>
          <th className="name no-select">Nombre</th>
          <th className="name no-select" style={{ width: '130px' }}>Documento</th>
          <th className="name no-select">Gestor</th>
          <th className="name no-select" style={{ width: '130px' }}>Fecha</th>
          <th className="name no-select" style={{ width: '120px' }}>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {props.list.map((item) => (
          <tr key={"row-table-hg-ash-" + item.id}>
            <td className="user">
              {`${item.nombre ?? ''} ${item.primerApellido ?? ''} ${item.segundoApellido ?? ''}`}
            </td>
            <td className="user no-select" style={{ width: '130px' }}>{item.documento}</td>
            <td className="user no-select">{item.iep}</td>
            {/* <td className="user" style={{ width: '100px' }}>{item.qr}</td> */}
            <td className="user" style={{ width: '130px' }}>{item.now ? item.now.split('T')[0]: ''}</td>
            <td className="user no-select pointer" style={{ width: '120px' }}>
              <div className="flex-center">
                <div onClick={() => props.onGetPdf(item.id)} className={'kml-input-form-bottons red-background-color on-mouse-hover'} title={'Descargar PDF'}>
                  <i className="fa fa-file-pdf"></i>
                </div>
                <div onClick={() => props.onGetQr(item.qr)} className={'kml-input-form-bottons primary-background-color on-mouse-hover'} title={'Descargar Código QR: ' + item.qr}>
                  <i className="fas fa-qrcode"></i>
                </div>
                <div onClick={() => props.onOpenQr(item.id)} className={'kml-input-form-bottons green-background-color on-mouse-hover'} title={'Ver información'}>
                  <i className="fas fa-eye"></i>
                </div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default EpTable;
